window.BrandNavigatorUtils = {};

BrandNavigatorUtils.buildSelectedBrandsTree = function (access_brands_tree) {
    var tree = [];
    if (access_brands_tree && (access_brands_tree.length > 0)) {

        for (var i in access_brands_tree) {

            var accessBrand = access_brands_tree[i];

            if (!accessBrand.include_children && accessBrand.type === 'enterprise') {
                accessBrand.brand_id = accessBrand.id;
                accessBrand.id = "child_" + accessBrand.id;
                accessBrand.type = "child";
                accessBrand.parents_ids.unshift(accessBrand.id);
            }
        }

        var treeParentId = access_brands_tree[0].parents_ids[access_brands_tree[0].parents_ids.length - 1];
        tree.push({
            id: treeParentId,
            brands: []
        });

        var addBrandToTree = function (brands, level, brandId, parentId, brandName) {
            if (level === 0) {
                for (var j in brands) {
                    var parentBrand = brands[j];
                    if (parentBrand.id === parentId) {

                        var isElementAdded = false;
                        for (var k in parentBrand.brands) {
                            var childBrand = parentBrand.brands[k];
                            if (childBrand.id === brandId) {
                                isElementAdded = true;
                                break;
                            }
                        }

                        if (!isElementAdded) {
                            var brandItem = {
                                id: brandId,
                                brands: []
                            };
                            if (brandName) {
                                brandItem['name'] = brandName;
                            }
                            brands[j].brands.push(brandItem);
                        }
                        break;
                    }
                }
                return;
            }

            for (var i in brands) {
                addBrandToTree(brands[i].brands, level - 1, brandId, parentId, brandName);
            }
        };

        for (var i in access_brands_tree) {
            var accessBrand = access_brands_tree[i];

            for (var j = accessBrand.parents_ids.length - 2; j >= 0; j--) {
                var brandId = accessBrand.parents_ids[j];
                var parentId = accessBrand.parents_ids[j + 1];
                var level = accessBrand.parents_ids.length - j - 2;

                if (accessBrand.id === brandId) {
                    addBrandToTree(tree, level, brandId, parentId, accessBrand.name);
                } else {
                    addBrandToTree(tree, level, brandId, parentId);
                }
            }
        }
    }
    return tree;
};

BrandNavigatorUtils.getParentIdsFromMapping = function (brandMappingsObj, brandId) {
    var parents = [brandId];
    var brand = brandMappingsObj[brandId];

    if (brand && brand['parent_id']) {
        parents = parents.concat(BrandNavigatorUtils.getParentIdsFromMapping(brandMappingsObj, brand['parent_id']));
    }

    return parents;
};

Object.freeze(BrandNavigatorUtils);
